import React from 'react';
import PropTypes from 'prop-types';
import DescriptionListItem from '../../../v2/DescriptionListItem';
import EditButton from '../../../v2/buttons/EditButton';
import CargomaticInput from '../../../v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class ShipmentDetailValueItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      value: this.props.value,
    };
  }

  handleSave = () => {
    this.setState({ showEdit: false }, this.props.onSave(this.state.value));
  };

  renderEditForm() {
    const { t, dataTestId } = this.props;
    return (
      (<div data-testid={dataTestId}>
        <CargomaticInput
          dataTestId="CargomaticInput-2f411f15"
          type="textarea"
          className="mb-4"
          label={this.state.title}
          value={this.state.value}
          rows={this.props.rows}
          onChange={(value) => {
            this.setState({ value });
          }} />
        <div data-testid="div-c4861608" className="form-actions space-x-2">
          <button
            data-testid="button-c5741bd8"
            type="button"
            className="button button-green"
            onClick={this.handleSave}>
            {titleize(t('SAVE'))}
          </button>
          <button
            data-testid="button-4c134ce2"
            type="button"
            className="button button-secondary"
            onClick={() => {
              this.setState({ showEdit: false, value: this.props.value });
            }}>
            {t('CANCEL')}
          </button>
        </div>
      </div>)
    );
  }
  render() {
    const { t, dataTestId } = this.props;
    return (
      (<div data-testid={dataTestId}>
        <DescriptionListItem dataTestId="DescriptionListItem-a512b612" label={this.props.title}>
          {this.state.showEdit && this.renderEditForm()}
          {!this.state.showEdit && (
            <div data-testid="div-c39f514f" className="flex items-center space-x-2">
              <span data-testid="span-54624708">{this.state.value || t('NOT_SET')}</span>
              {this.props.editable && (
                <EditButton
                  dataTestId="EditButton-e6b0296b"
                  onClick={() => {
                    this.setState({ showEdit: true, value: this.props.value });
                  }} />
              )}
            </div>
          )}
        </DescriptionListItem>
      </div>)
    );
  }
}

ShipmentDetailValueItem.propTypes = {
  editable: PropTypes.bool,
  rows: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.string,
  onSave: PropTypes.func,
};

ShipmentDetailValueItem.defaultProps = {
  title: '',
  rows: 1,
  onSave: () => {},
  value: '',
  editable: false,
};

export default withTranslation()(ShipmentDetailValueItem);
